import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/header-mobile2.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/AnimatedLink/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["ArrowScroll"] */ "/vercel/path0/src/components/ArrowScroll/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeExperiences"] */ "/vercel/path0/src/components/HomeSections/HomeExperiences/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeFeaturedVillas"] */ "/vercel/path0/src/components/HomeSections/HomeFeaturedVillas/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeFeatures"] */ "/vercel/path0/src/components/HomeSections/HomeFeatures/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomePress"] */ "/vercel/path0/src/components/HomeSections/HomePress/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeRegions"] */ "/vercel/path0/src/components/HomeSections/HomeRegions/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeTravelJournal"] */ "/vercel/path0/src/components/HomeSections/HomeTravelJournal/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeVideoEmbed"] */ "/vercel/path0/src/components/HomeSections/HomeVideoEmbed/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/HomeSections/HomeVillaTypes/HomeVillasCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/HomeSections/HomeVillaTypes/styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["Reviews"] */ "/vercel/path0/src/components/Reviews/index.tsx");
